<template>
  <v-toolbar app>
    <!--<v-toolbar-side-icon></v-toolbar-side-icon>-->
    <v-toolbar-title class="headline text-uppercase">
        <v-img src="drussen_logo.svg" width="223" height="60"></v-img>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-btn v-if="isLoggedIn" icon @click="reloadData"><v-icon>fal fa-sync</v-icon></v-btn>
      <v-btn v-if="isLoggedIn" flat>{{ event.title }}</v-btn>
      <v-btn v-if="isLoggedIn" flat @click="$emit('open-profile-dialog')">
        <v-icon class="mr-2">fal fa-user</v-icon>
        {{ firstname }} {{ lastname }}</v-btn>
      <v-btn v-if="isLoggedIn" icon @click="logout"><v-icon>fal fa-sign-out</v-icon></v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
  export default {
    props: {
      event: {
        type: Object,
        default: function () {
          return {
            'title': 'Eventname'
          }
        }
      }
    },
    computed: {
      isLoggedIn () {
        return this.$store.getters.isLoggedIn
      },
      firstname () {
        if (this.isLoggedIn && this.$store.state.user !== undefined) {
          return this.$store.state.user.firstname
        }

        return ''
      },
      lastname () {
        if (this.isLoggedIn && this.$store.state.user !== undefined) {
          return this.$store.state.user.lastname
        }

        return ''
      }
    },
    methods: {
      reloadData () {
        this.$store.dispatch('reloadData')
      },
      logout: function () {
        this.$store.dispatch('logout')
          .then(() => this.$router.push('/'))
      }
    },
    data: () => ({

    })
  }
</script>

<style>

</style>
